import type { ParamsSerializerOptions } from 'axios';

/**
 * The API binds repeated query keys (`collection_type=a&collection_type=b`).
 * Axios otherwise sends `collection_type[]=a`, which is ignored, so a category
 * filter returns every school period.
 */
export const alltixParamsSerializer: ParamsSerializerOptions = {
  indexes: null,
};
